export default __webpack_public_path__ + "static/media/dr-megha-cutis.3f002032.jpg";